import { createActionTypes } from '../../shared/actions';
import { ACTIONS_NAMESPACE } from '../../shared/constants';

export const typeLogin = 'LOGIN';

export const namespace = `${ACTIONS_NAMESPACE}/LoginPage`;

const login = createActionTypes(typeLogin, namespace);

export default {
  ...login
};



// WEBPACK FOOTER //
// ./src/containers/LoginPage/constants.js